import { Component, OnInit } from "@angular/core";
import { ContentService } from "../../shared/services/content.service";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-aurea",
  templateUrl: "./aurea.component.html",
  styleUrls: ["./aurea.component.scss"],
})
export class AureaComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService, private meta: Meta) {
    this.meta.addTags([
      {
        name: "title",
        content:
          "Visual identity voor Aurea, hoogwaardig design met een onderscheidend karakter | Lemonfish",
      },

      {
        name: "description",
        content:
          "Ontwerp voor de visuele identiteit van Aurea, die elke ruimte tot iets unieks transformeert, met hoogwaardige en authentieke vloeren en wanden.",
      },
    ]);
  }
  ngOnInit() {
    this.page = this.contentService.pages["aurea"];
  }
}
